/**
 * Created by tomers on 12/24/2014.
 */
define(function (require) {
    "use strict";

    //<editor-fold desc="require-region">
    /*-----------------------------------------------------------------------------------------------*/
    var Marionette = require("marionette");
    var Logger = require("logger");
    var _ = require("underscore");

    //Template
    var listItemTemplate = require("ui/list/templates/listItem.tmpl");
    var listItemNoItemsTemplate = require("ui/list/templates/listItemNoItems.tmpl");
    var listItemNewItemTemplate = require("ui/list/templates/listItemNewItem.tmpl");

    //ui components
    var Checkbox = require("ui/checkbox/Checkbox");
    var DomUtilities = require('infra-util/DomUtilities');

    var NO_ITEMS_ID;
    var NEW_ITEM_ID;
    var LIST_ITEM_CLASS_NAME = "list-item-container";
    var LIST_ITEM_DATA_ID_ATTRIBUTE = "data-id";
    var HIDE_CLASS_NAME = "hide";
    var DISABLED_CLASS_NAME = "disabled";
    var SELECTED_CLASS_NAME = "selected";
    var ACTIVE_CLASS_NAME = "active";
    var CHECKBOX_CLASS_NAME = "checkbox-enabled";
    var HIGHLIGHT_CLASS_NAME = "highlight";

    //</editor-fold>

    var ListItemView = Marionette.ItemView.extend({

        //<editor-fold desc="extended definitions">
        /*-----------------------------------------------------------------------------------------------*/
        tagName: "li",
        className: LIST_ITEM_CLASS_NAME,
        ui: {
            checkboxContainer: ".list-item-checkbox-container",
            contentContainer: ".list-item-content-container",
            valueContainer: ".list-item-content-value",
            subTextContainer: ".list-item-content-sub-text span",
            actionsContainer: ".list-item-actions-container",
            actionsAddContainer: ".list-item-action-add-container",
            actionsSelectContainer: ".list-item-action-select-container",
            actionsRemoveContainer: ".list-item-action-remove-container"
        },
        withUIComponents:true,
        events: {
            "click .add-icon": "_onItemActionAddClick",
            "keydown .add-icon": "_onItemActionAddKeydown",
            "click .select-icon": "_onItemActionSelectClick",
            "keydown .select-icon": "_onItemActionSelectKeydown",
            "click .remove-icon": "_onItemActionRemoveClick",
            "keydown .remove-icon": "_onItemActionRemoveKeydown",
            "mouseover": "_onItemMouseEnter",
            "focusin": "_onItemMouseEnter",
            "mouseout": "_onItemMouseLeave",
            "focusout": "_onItemMouseLeave",
            "click": "_onItemClick",
            "keydown": "_onItemKeydown"
        },
        //</editor-fold>


        //<editor-fold desc="Marionette-Functions">
        /*-----------------------------------------------------------------------------------------------*/
        initialize: function (options) {
            this._initialize(options);
        },
        onRender: function () {
            this._onRender();
        },
        //</editor-fold>

        //<editor-fold desc="publicFunctions">
        /*-----------------------------------------------------------------------------------------------*/
        setError: function(isError, msg) {
            this._setError(isError, msg);
        },

        //</editor-fold>

        //<editor-fold desc="privateFunctions">
        /*-----------------------------------------------------------------------------------------------*/
        _initialize: function (options) {
            this.logger = Logger.getLogger("List");
            this.logger.debug("Initializing List Item View", "ListItemView:_initialize", {options:options});
            this.model = options.model;

            NO_ITEMS_ID = this.model.NO_ITEMS_ID;
            NEW_ITEM_ID = this.model.NEW_ITEM_ID;
            this.template = _getTemplateById(this.model.id);
            this.hasCheckbox = options.hasCheckbox;
            this.isNightTheme = options.isNightTheme;
        },

        _onRender: function () {
            this.logger.debug("Rendering List Item View", "ListItemView:_onRender");
            this.$el.data(LIST_ITEM_DATA_ID_ATTRIBUTE, this.model.id);
            this.$el.attr("id", _.uniqueId("list-item-"));
            this._renderCheckbox();
            this._renderActions();

            this._updateClassName();

            this._updateTooltip();
            this._updateVisible();
            this._updateEnabled();
            this._updateSelected();

            this._highlightFilteredValue();

            this._bindEventsToModel();
        },

        _bindEventsToModel: function () {
            this.listenTo(this.model, "change:tooltip", this._updateTooltip);
            this.listenTo(this.model, "change:visible", this._updateVisible);
            this.listenTo(this.model, "change:enabled", this._updateEnabled);
            this.listenTo(this.model, "change:selected", this._updateSelected);
            this.listenTo(this.model, "change:active", this._updateActive);
        },

        _onItemActionAddClick: function(e) {
            this.logger.info("list item - action clicked - add", "ListItemView:_onItemActionAddClick");

            e.stopPropagation();
            if (this.model.isEnabled()) {
                this.trigger("action-add-click");
            }
        },
        _onItemActionAddKeydown: function(e) {
            if (e.key === "Enter" || e.key === " ") {
                this._onItemActionAddClick(e);
            }
        },

        _onItemActionSelectClick: function(e) {
            this.logger.info("list item - action clicked - select", "ListItemView:_onItemActionSelectClick");
            e.stopPropagation();
            if (this.model.isEnabled()) {
                this.trigger("action-select-click");
            }
        },

        _onItemActionSelectKeydown: function(e) {
            if (e.key === "Enter" || e.key === " ") {
                this._onItemActionSelectClick(e);
            }
        },

        _onItemActionRemoveClick: function(e) {
            this.logger.info("list item - action clicked - remove", "ListItemView:_onItemActionRemoveClick");
            e.stopPropagation();
            if (this.model.isEnabled()) {
                this.trigger("action-remove-click");
            }
        },

        _onItemActionRemoveKeydown: function(e) {
            if (e.key === "Enter" || e.key === " ") {
                this._onItemActionRemoveClick(e);
            }
        },

        _onItemMouseEnter: function() {
            if (this.model.isEnabled()) {
                this.ui.actionsContainer.removeClass("hide");
                this.trigger("mouseenter");
            }
        },

        _onItemMouseLeave: function() {
            if (this.model.isEnabled()) {
                this.ui.actionsContainer.addClass("hide");
                this.trigger("mouseleave");
            }
        },

        _onItemClick: function(e) {
            this.logger.info("list item - item was clicked", "ListItemView:_onItemClick");
            if (this.model.isEnabled()) {
                this.trigger("click");
            }
            else {
                e.stopPropagation();
            }
        },

        _onItemKeydown: function(e) {
            if (e.key === "Enter" || e.key === " ") {
                this._onItemClick(e);
            }
        },

        _renderCheckbox: function () {
            this.$el.toggleClass(CHECKBOX_CLASS_NAME, this.hasCheckbox);
            if (this.hasCheckbox) {
                this.$el.attr("role", "checkbox");
                this.$el.attr("tabindex", "0");
                this.logger.debug("Rendering Checkbox", "ListItemView:_renderCheckbox");
                var checkboxPerm = this.isNightTheme ? Checkbox.PERMUTATION.NIGHT : Checkbox.PERMUTATION.B;
                this.uiComponents.host$.createAndRender("checkbox", {
                    type: Checkbox,
                    options: {
                        permutation: checkboxPerm,
                        el: "view.ui.checkboxContainer",
                        checked: "view._isSelected",
                        ariaDisable: true
                    }
                });
            }
        },
        _renderActions: function () {
            if (this.model.getActions().add !== false) {
                this.ui.actionsAddContainer.removeClass("hide");
            }

            if (this.model.getActions().select !== false) {
                this.ui.actionsSelectContainer.removeClass("hide");
            }

            if (this.model.getActions().remove !== false) {
                this.ui.actionsRemoveContainer.removeClass("hide");
            }
        },

        _updateClassName: function() {
            this.$el.addClass(this.model.getClassName());
        },

        _updateTooltip: function () {
            var tooltip = this.model.getTooltip();
            this.$el.attr("title", tooltip);
            this.$el.attr("tooltip-text", tooltip);
        },
        _updateVisible: function () {
            this.$el.toggleClass(HIDE_CLASS_NAME, !this.model.isVisible());
        },
        _updateActive: function() {
            this.$el.toggleClass(ACTIVE_CLASS_NAME, this.model.isActive());
        },
        _updateEnabled: function () {
            var isEnabled = this.model.isEnabled();
            this.$el.toggleClass(DISABLED_CLASS_NAME, !isEnabled);
            this.ui.contentContainer.toggleClass(DISABLED_CLASS_NAME, !isEnabled);

            if (this.uiComponents.checkbox) {
                this.uiComponents.checkbox.setEnabled(isEnabled);
            }
        },
        _updateSelected: function () {
            this.$el.toggleClass(SELECTED_CLASS_NAME, this.model.isSelected());
            this.$el.attr("aria-selected", this.model.isSelected() ? "true" : "false");

            if (this.uiComponents.checkbox) {
                this.uiComponents.checkbox.setCheckedState(this.model.isSelected());
            }
        },

        _setError: function(isError, msg) {
            if (this.uiComponents && this.uiComponents.checkbox) {
                this.uiComponents.checkbox.setError(isError, msg);
            }
        },

        _highlightFilteredValue: function() {
            var filteredValue = this.model.getFilteredValue();
            if (!_.isEmpty(filteredValue) && !this.model.isSpecialModel()) {
                this.logger.debug("Highlight list item", "ListItemView:_highlightFilteredValue", {filteredValue:filteredValue});

                if (this.model.isFilteredByValue()) {
                    this._highlightDomElement(filteredValue, this.ui.valueContainer);
                }

                if (this.model.isFilteredBySubText()) {
                    this._highlightDomElement(filteredValue, this.ui.subTextContainer);
                }
            }
        },

        _highlightDomElement: function(filteredValue, element) {
            var re = new RegExp(filteredValue, "i");
            var highlighted = element.clone();
            DomUtilities.highlight.call(this, highlighted[0].childNodes[0], re, "span", HIGHLIGHT_CLASS_NAME);
            element.html(highlighted.html());   // Must replace the html as a whole, otherwise some weird width
            // issues occur (the width of the container div of the checkbox
            // doesn't get updated).
        },

        _isSelected: function() {
            return this.model.isSelected();
        }
        //</editor-fold>
    });

    ////////////////////////////////////////////////////////////////////////////
    //Utility functions fold that does not need "this"
    ////////////////////////////////////////////////////////////////////////////
    function _getTemplateById(id) {
        var template;
        switch(id) {
            case NO_ITEMS_ID:
                template = listItemNoItemsTemplate;
                break;
            case NEW_ITEM_ID:
                template = listItemNewItemTemplate;
                break;
            default:
                template = listItemTemplate;
                break;
        }
        return template;
    }

    ListItemView.LIST_ITEM_CLASS_NAME = LIST_ITEM_CLASS_NAME;
    ListItemView.ACTIVE_CLASS_NAME = ACTIVE_CLASS_NAME;
    ListItemView.DATA_ID_ATTRIBUTE = LIST_ITEM_DATA_ID_ATTRIBUTE;

    return ListItemView;

});
